
var space = require('to-space-case')

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/to-camel-case/index.js
 ** module id = 1181
 ** module chunks = 0
 **/